import { render } from "./forgot-password.vue?vue&type=template&id=53fa0187"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/forgot-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53fa0187"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53fa0187', __exports__)) {
    console.log('reload')
    api.reload('53fa0187', __exports__)
  }
  
  module.hot.accept("./forgot-password.vue?vue&type=template&id=53fa0187", () => {
    console.log('re-render')
    api.rerender('53fa0187', render)
  })

}


export default __exports__